import { Directive, HostListener } from "@angular/core";
import { InputManager } from "./input-manager";
var CanvasController = (function () {
    function CanvasController(input_manager_) {
        this.input_manager_ = input_manager_;
    }
    ;
    CanvasController.prototype.setMouseUp = function (event) {
        event.stopPropagation();
        if (event.button == 0) {
            this.input_manager_.setMouseButton("left", false);
        }
        else if (event.button == 2) {
            this.input_manager_.setMouseButton("right", false);
        }
    };
    ;
    CanvasController.prototype.setMouseDown = function (event) {
        event.stopPropagation();
        if (event.button == 0) {
            this.input_manager_.setMouseButton("left", true);
        }
        else if (event.button == 2) {
            this.input_manager_.setMouseButton("right", true);
        }
    };
    ;
    CanvasController.prototype.onMouseWheel = function (event) {
        var scroll = (event.deltaY > 0) ? 1 : -1;
        this.input_manager_.setWheelDirection(scroll);
        return false;
    };
    ;
    CanvasController.prototype.onMouseMove = function (event) {
        this.input_manager_.setMousePosition({ x: event.clientX, y: event.clientY });
        return false;
    };
    ;
    CanvasController.decorators = [
        { type: Directive, args: [{
                    selector: "[canvas-controller]"
                },] },
    ];
    CanvasController.ctorParameters = function () { return [
        { type: InputManager, },
    ]; };
    CanvasController.propDecorators = {
        "setMouseUp": [{ type: HostListener, args: ["mouseup", ["$event"],] },],
        "setMouseDown": [{ type: HostListener, args: ["mousedown", ["$event"],] },],
        "onMouseWheel": [{ type: HostListener, args: ["wheel", ["$event"],] },],
        "onMouseMove": [{ type: HostListener, args: ["mousemove", ["$event"],] },],
    };
    return CanvasController;
}());
export { CanvasController };
//# sourceMappingURL=canvas-controller.directive.js.map